type InteractionState = 'hover' | 'select'

export function Interaction({
  state,
  className = '',
}: {
  state: InteractionState
  className?: string
}) {
  return (
    <span
      aria-hidden="true"
      className={[
        'pointer-events-none rounded-[14px] bg-violet-500',
        // 3% · 9% 는 Tailwind 기본 눈금에 없다 — 시안 값 그대로 적는다.
        state === 'hover' ? 'opacity-[0.03]' : 'opacity-[0.09]',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    />
  )
}
